<template>
  <section class="commissions-list">
    <stores-filters
      class="commissions-list-filters"
      scrollable
    />

    <ul
      ref="scroller"
      class="commissions-list-items"
    >
      <simple-list-item
        v-for="item in ($route.params.store_id ? kinds : list)"
        :key="`${item.title}-${item.value}`"
        :item="item"
      />

      <context-state
        v-if="currentState"
        key="context"
        :state="currentState"
        tag="li"
      >
        <template v-slot:loading>
          Carregando lojas...
        </template>

        <template v-slot:error>
          {{ currentError }}
        </template>

        <template v-slot:notfound>
          Nenhuma loja encontrada :(
        </template>

        <template v-slot:empty>
          Sem mais lojas
        </template>
      </context-state>
    </ul>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import { alphabetical } from '@cordel/helpers/form/select/options';

  import ContextState from '@cordel/components/Context/State.vue';
  import SimpleListItem from '@cordel/components/List/Simple.vue';

  import StoresFilters from '@sdk/components/Filters/Stores/List.vue';

  import KINDS from './List/kinds';

  export default {
    name: 'ReturnsIndex',
    components: {
      ContextState,
      SimpleListItem,

      StoresFilters,
    },
    computed: {
      ...mapState([
        'stores',
      ]),

      list() {
        return Object
          .values(this.stores.list.items)
          .map(store => ({
            title: store.name,
            value: store.id,
            href: this.$router.resolve({
              params: {
                store_id: store.id,
              },
            }).href,
          }))
          .sort((a, b) => alphabetical(a.title, b.title));
      },
      loading() {
        return this.stores.list.loading;
      },
      error() {
        return this.stores.list.error;
      },

      currentState() {
        if (this.loading) {
          return 'loading';
        }

        if (this.error) {
          return 'error';
        }

        if (this.list.length === 0) {
          return 'notfound';
        }

        return 'empty';
      },

      kinds() {
        return Object.keys(KINDS).map(i => ({
          title: `${KINDS[i].title} (${KINDS[i].description})`,
          value: i.toLowerCase(),
          href: this.$router.resolve({
            name: 'settings-commercial-commissions-form',
            params: {
              store_id: this.$route.params.store_id,
              kind: i.toLowerCase(),
            },
          }).href,
        }));
      },
    },
  };
</script>

<style lang="scss">
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .commissions-list-filters {
    .cordel-section-item {
      margin-top: 0;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .commissions-list-items {
    list-style: none;
    margin-top: var(--cordel-spacing-xl);
  }
</style>
